export default {
  header: {
    home: '홈',
    categories: '카테고리',
    about: '소개',
    searchPlaceholder: '게임 검색...',
    toggleDarkMode: '다크 모드로 전환',
    toggleLightMode: '라이트 모드로 전환',
    changeLanguage: '언어 변경'
  },
  nav: {
    home: '홈',
    categories: '카테고리',
    popular: '인기',
    favorites: '즐겨찾기',
    search: '검색...',
    login: '로그인',
    register: '회원가입',
    myProfile: '내 프로필',
    settings: '설정',
    logout: '로그아웃',
    darkMode: '다크 모드',
    lightMode: '라이트 모드',
    language: '언어',
    about: '소개'
  },
  footer: {
    about: '우리 소개',
    contact: '문의하기',
    contactUs: '문의하기',
    policy: '개인정보 처리방침',
    terms: '이용약관',
    copyright: '© {year} GoGameVault. All rights reserved.',
    playOnline: '온라인 플레이',
    bestGames: '베스트 게임',
    newGames: '신규 게임',
    popularGames: '인기 게임',
    followUs: '팔로우하기',
    disclaimer: '모든 게임은 원작자에게 귀속됩니다. 본 사이트는 어떠한 권리도 주장하지 않습니다.',
    introText: '최고의 무료 온라인 게임 플랫폼. 다운로드 불필요, 가입 불필요, 순수한 즐거움!',
    quickLinks: '빠른 링크',
    popularCategories: '인기 카테고리',
    contactText: '질문, 제안, 피드백이 있으신가요? 언제든 문의해주세요!',
    aboutUs: '우리 소개'
  },
  gameCard: {
    play: '지금 플레이',
    new: '신규',
    popular: '인기'
  },
  shareButtons: {
    share: '공유',
    copyLink: '링크 복사',
    facebook: 'Facebook으로 공유',
    twitter: 'Twitter로 공유',
    whatsapp: 'WhatsApp으로 공유',
    telegram: 'Telegram으로 공유',
    copied: '복사되었습니다!'
  },
  searchBar: {
    search: '검색',
    placeholder: '좋아하는 게임 찾기...'
  },
  share: {
    title: '공유',
    copy: '링크 복사',
    copied: '복사됨',
    instagramNotSupported: 'Instagram은 직접 링크 공유를 지원하지 않습니다'
  },
  defaultGameImage: {
    text: '게임 이미지'
  }
}; 